$( document ).ready(function() {
    /**
     * To open popup when click on contact button
     */
    $('.contact_popup')
      .on('click', function (e) {
        //alert();
        e.preventDefault();
        $('.contact_page_show')
          .modal('show');
      });
    /**
     * Replace the html of modal
     */
    $("#next_button_contact")
      .on('click', function () {
        $('.contact_page_show')
          .modal('hide');
        $('.contact_page_form_show')
          .modal('show');
      });
    /**
     * Refresh the modal on close
     */
    $('.contact_page_form_show')
      .on('hidden.bs.modal', function () {
        location.reload();
      });
  });
